var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.61976 17.3184V14.7627C7.61974 14.1151 8.14637 13.5889 8.79868 13.5849H11.1938C11.849 13.5849 12.3802 14.1122 12.3802 14.7627V17.311C12.3802 17.8728 12.8367 18.3293 13.4024 18.3334H15.0365C15.7997 18.3353 16.5323 18.0357 17.0726 17.5006C17.613 16.9655 17.9166 16.239 17.9166 15.4813V8.22156C17.9166 7.60951 17.6434 7.02895 17.1705 6.63627L11.6191 2.22858C10.6487 1.45762 9.26279 1.48253 8.32114 2.28784L2.88916 6.63627C2.39393 7.01737 2.09794 7.59966 2.08331 8.22156V15.4739C2.08331 17.0531 3.3728 18.3334 4.96346 18.3334H6.56022C6.83262 18.3353 7.09455 18.2292 7.28787 18.0387C7.4812 17.8482 7.58992 17.5889 7.58991 17.3184H7.61976Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon__home.31c66e6163787042d119d49c2bedb233.svg";
export { ForwardRef as ReactComponent };